export const createUnknownError = () => new DOMException('', 'UnknownError');
//# sourceMappingURL=unknown-error.js.map